import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";

import { Title } from "@ui5/webcomponents-react/lib/Title";
import { TitleLevel } from "@ui5/webcomponents-react/lib/TitleLevel";
import { PageBackgroundDesign } from "@ui5/webcomponents-react/lib/PageBackgroundDesign";
import { Page } from "@ui5/webcomponents-react/lib/Page";
import { Button } from "@ui5/webcomponents-react/lib/Button";
import { ButtonDesign } from "@ui5/webcomponents-react/lib/ButtonDesign";
import MessageStripCompnt from "../../shared/components/UIElements/MessageStrip";

import "./Home.css";
import axios from "axios";

const Home = (props) => {
  const [userName, setUserName] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const getUserName = async () => {
      await axios
        .get(`api/users/` + props.user, {
          headers: { Authorization: props.token },
        })
        .then(function (response) {
          setUserName(response.data.rows[0].ApprovalUserName);
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.status === 401) {
              setError(error.response.data.message);
              props.handleLogout();
            } else {
              setError(error.response.data.message);
            }
          } else {
            setError(
              "Something went wrong. Please verify your Internet connection."
            );
          }
        });
    };

    getUserName();
  }, []);

  return (
    <Page
      title={"Home Page"}
      showFooter={false}
      showHeader={true}
      showBackButton={false}
      backgroundDesign={PageBackgroundDesign.Transparent}
      onNavButtonPress={null}
    >
      <div className="home__container">
        <Title level={TitleLevel.H3} wrap={false}>
          {String(new Date().getDate()).padStart(2, "0") +
            "/" +
            String(new Date().getMonth() + 1).padStart(2, "0") +
            "/" +
            new Date().getFullYear()}
        </Title>
        <Title level={TitleLevel.H2} wrap={false}>
          <b>{props.company.split("(")[0]}</b>
          <br />
          {props.company.split("(")[1].slice(0, -1)}
        </Title>
        <Title level={TitleLevel.H2} wrap={false}>
          <br />
          Welcome {userName}!
        </Title>
        <br />
        <br />
        <br />
        <br />
        <Button
          onClick={() => {
            props.history.push("/approvals");
          }}
          design={ButtonDesign.Emphasized}
        >
          Payment Run Approvals
        </Button>
        <br/>
        {error && (
          <MessageStripCompnt
            className="message_strip"
            type="info"
            message={error}
          />
        )}
      </div>
    </Page>
  );
};

export default withRouter(Home);
